import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request";
import { getClientAppData } from "@/js/http/auth";
import { getErrorData, filterVAutocomplete } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import SupplierDialog from "@/components/supplier-prices/SupplierDialog.vue";
export default {
  name: "SupplierSelectComponent",
  components: {
    SupplierDialog: SupplierDialog,
    Confirm: Confirm
  },
  props: {
    suppliers: {
      type: Array,
      default: []
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selected: Number,
    required: Boolean,
    disabled: Boolean,
    clearable: Boolean,
    label: {
      type: String,
      default: "Supplier"
    },
    hideSelected: Boolean,
    classStyle: String
  },
  data: function data() {
    return {
      clientAppData: null,
      isReloading: false,
      isLoadingCountries: false,
      supplierModalShown: false,
      editSupplier: null,
      model: {
        id: null,
        display_name: null
      },
      countries: [],
      states: []
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.clientAppData = getClientAppData(_this2);
            _this2.fetchCountries();
            if (_this2.selected) {
              _this2.model = _this2.suppliers.find(function (x) {
                return x.id == _this2.selected;
              });
            } else {
              _this2.model = null;
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    changeSupplier: function changeSupplier(item) {
      this.$emit("changeSupplier", item ? item.id : null);
    },
    updateModel: function updateModel(supplierId) {
      this.model = this.suppliers.find(function (x) {
        return x.id == supplierId;
      });
      this.isReloading = false;
    },
    fetchCountries: function fetchCountries() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingCountries = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/countries", "post", _this3.clientAppData, false, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load intended countries.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 4:
              response = _context2.sent;
              if (response) {
                _this3.countries = _toConsumableArray(response.data.countries);
                _this3.states = _toConsumableArray(response.data.states);
                _this3.isLoadingCountries = false;
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    saveSupplier: function saveSupplier(supplier, ackowledge) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isReloading = true;
              _this = _this4;
              if (!supplier.id) {
                _context3.next = 8;
                break;
              }
              _context3.next = 5;
              return request("/v1/suppliers/".concat(supplier.id), "put", supplier, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the supplier.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                ackowledge();
                throw e;
              });
            case 5:
              _this4.$emit("fetchSuppliers", +supplier.id);
              _context3.next = 12;
              break;
            case 8:
              _context3.next = 10;
              return request("/v1/suppliers", "post", supplier, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the supplier.");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                ackowledge();
                throw e;
              });
            case 10:
              response = _context3.sent;
              _this4.$emit("fetchSuppliers", +response.data.value);
            case 12:
              ackowledge();
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    closeNewSupplierDialog: function closeNewSupplierDialog() {
      this.supplierModalShown = false;
    },
    filterVAutocomplete: filterVAutocomplete
  }
};